import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import MapPropTypes from '../../MapPropTypes';
import strings from '../../../strings';
import utils from '../../../utils';
import './Summary.scss';
import { Scrollbars } from 'react-custom-scrollbars';

class Summary extends Component {
    static propTypes = {
        cartTotal: PropTypes.number.isRequired,
        offer: MapPropTypes.OfferProps.isRequired,
        cart: MapPropTypes.CartProps.isRequired,
        onUpdateInstructions: PropTypes.func.isRequired,
        excelUpload: PropTypes.bool,
        sheetResponseData: PropTypes.object,
        soldTo: PropTypes.string,
    };

    _showEndDate() {
        if (this.props.offer.enterprise_deal || utils.isDateRangeSoldTO(this.props.soldTo) || this.props.offer.dailyPricingEnabled) {
            return true;
        } else {
            return false;
        }
    }

    _showDays() {
        if (this.props.offer.dailyPricingEnabled) {
            return true;
        } else {
            return false;
        }
    }

    _renderSummary() {
        if (!this.props.excelUpload == true) {
            return (
                <dl className="dl-horizontal">
                    <dt className="col-md-7 display-3">
                        {strings.creditsUsed}
                    </dt>
                    <dd className="col-md-5 text-info display-3 text-emphasis-strong">
                        {utils.formatPrice(this.props.cartTotal)}
                    </dd>
                    <dt className="col-md-7">{strings.availableCredits}</dt>
                    <dd className="col-md-5">
                        {utils.formatPrice(this.props.offer.balance)}
                    </dd>
                    <dt className="col-md-7">{strings.remaining}</dt>
                    <dd className="col-md-5 text-success">
                        {utils.formatPrice(
                            this.props.offer.balance - this.props.cartTotal
                        )}
                    </dd>
                </dl>
            );
        }
    }

    _renderPurchases() {
        return (
            <div>
                <div className="text-xs text-uppercase text-muted m-b-xs">
                    {strings.order}
                </div>
                <Scrollbars
                    style={{ width: '100%', height: 260 }}
                    universal={true}
                >
                    <table className="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>{strings.partNumber}</th>
                                <th>{strings.product}</th>
                                <th>{strings.seats}</th>
                                {this._showEndDate() &&  <th>Start Date</th>}
                                {this._showEndDate() &&  <th>End Date</th>}
                                {!this._showDays() &&  <th>{strings.months}</th>}
                                {this._showDays() &&  <th>{strings.days}</th>}
                                {this.props.offer.weeklyPricingEnabled && ( <th>{strings.weeks}</th> )}
                                <th>{strings.subtotal}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.cart
                            .filter(item => this.props.excelUpload || (item.addedToCart && !item.saveForLater)).map((item, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{item.pricing.product.mentorId}</td>
                                        <td>{item.pricing.product.name}</td>
                                        <td>{item.seats}</td>
                                        {this._showEndDate() && (
                                            <td className="text-nowrap">
                                                {moment(item.startDate).format('MM-DD-YYYY')}
                                            </td> )}     
                                        {this._showEndDate() &&  (
                                            <td className="text-nowrap">
                                                {moment(item.endDate).format('MM-DD-YYYY')}
                                            </td> )}                                     
                                        {!this._showDays() &&  (<td>{item.monthCount}</td> )}
                                        {this._showDays() &&  ( <td>{item.dayCount}</td> )}

                                        {this.props.offer.weeklyPricingEnabled && ( <td>{item.weekCount}</td> )}
                                        <td>
                                            {utils.formatPrice(item.subtotal)}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </Scrollbars>
            </div>
        );
    }

    _renderCommentForm() {
        return (
            <div>
                <label className="text-xs text-uppercase text-muted m-b-xs">
                    {strings.notes}
                </label>
                <textarea
                    className="form-control comment-field m-b"
                    placeholder={strings.enterSpecialInstructions}
                    onChange={(event) => this.props.onUpdateInstructions(event)}
                />
            </div>
        );
    }

    render() {
        return (
            <div className="checkout-summary">
                {this._renderSummary()}
                {this._renderPurchases()}
                {this._renderCommentForm()}
            </div>
        );
    }
}

export default Summary;



// WEBPACK FOOTER //
// ./app/components/Modals/CheckoutModal/Summary.jsx